import React, { useEffect, useState } from 'react';

import type { StylingProps } from '@builder4/shared/types/layout';
import type { PaddingMarginValues } from '@/types/layout';
import { PaddingMarginFields } from './PaddingMarginFields';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';
import { useInspectorNode } from '@/hooks/useInspectorNode';

interface MarginControlProps {
  onFocus?: () => void;
  onBlur?: () => void;
  value: PaddingMarginValues;
}

export const NodeMarginSettingsV2: React.FC<MarginControlProps> = ({ onFocus, onBlur, value }) => {
  const { id, node, actions } = useInspectorNode();
  const displayName = node?.data.displayName || '';
  const [variant, setVariant] = useState<'locked' | 'unlocked'>('locked');
  const { setBPProp } = useBreakpointAwareProp(displayName);

  useEffect(() => {
    let hasSame = !!value.all;
    if (!hasSame) {
      // Check if all individual values are equal
      hasSame =
        value.top === value.right && value.right === value.bottom && value.bottom === value.left;
    }
    setVariant(hasSame ? 'locked' : 'unlocked');
  }, []);

  const onChangeHandler = (e: PaddingMarginValues) => {
    actions.history.ignore().setProp(id, (props: Partial<StylingProps>) => {
      setBPProp(props, 'margin', [e.top, e.right, e.bottom, e.left]);
    });
  };
  const handleChangeComplete = (
    newValues: PaddingMarginValues,
    initialValues: PaddingMarginValues,
  ) => {
    actions.history.ignore().setProp(id, (props: Partial<StylingProps>) => {
      setBPProp(props, 'margin', [
        initialValues.top,
        initialValues.right,
        initialValues.bottom,
        initialValues.left,
      ]);
    });
    actions.setProp(id, (props: Partial<StylingProps>) => {
      setBPProp(props, 'margin', [
        newValues.top,
        newValues.right,
        newValues.bottom,
        newValues.left,
      ]);
    });
  };
  return (
    <PaddingMarginFields
      label="Margin"
      className="w-full max-w-[216px]"
      value={value}
      variant={variant}
      setVariant={setVariant}
      onChange={onChangeHandler}
      onBlur={onBlur}
      onFocus={onFocus}
      onChangeComplete={handleChangeComplete}
    />
  );
};
